import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'
import router from './router'
import store from './store'
import _ from "lodash"

import './assets/js/waves.js'

import './plugins/moments.js'
import './plugins/elements.js'
//滚轮
import './plugins/vuescroll.js'


import VueKatex from 'vue-katex'
import 'katex/dist/katex.min.css';
Vue.use(VueKatex);
//拖动
import VueDragResize from 'vue-drag-resize'
Vue.component('vue-drag-resize', VueDragResize)

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll);

import webSocket from './services/webSocket'
Vue.prototype.$wApi = webSocket;
webSocket.initWebSocket();

import Print from 'vue-print-nb'
Vue.use(Print);

Vue.config.productionTip = false;

import 'v-charts/lib/style.css';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);


import Win from './modal/Modal.js'
import func from'./plugins/functions.js'

Vue.prototype.$Win = Win;
Vue.prototype.router = router;
Vue.prototype.$store = store;
Vue.prototype.$axios = axios;
Vue.prototype._ = _;

Vue.prototype.$func=func;
Vue.prototype.$ops={
    rail: {
        size: '3px',
        gutterOfSide: '3px'
    },
    bar: {
        keepShow: true,
        background: 'rgba(144, 147, 153, 0.3)'
    },
};

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'

import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table-plugin-element/dist/style.css'

Vue.use(VXETable);
VXETable.use(VXETablePluginElement);


store.commit('refreshToken', localStorage.token);


Vue.filter('currency', function(value, _currency, decimals) {
    value = parseFloat(value);
    if (!isFinite(value) || !value && value !== 0) return '';
    _currency = _currency != null ? _currency : '$';
    decimals = decimals != null ? decimals : 2;
    var stringified = Math.abs(value).toFixed(decimals);
    var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
    var i = _int.length % 3;
    var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
    var _float = decimals ? stringified.slice(-1 - decimals) : '';
    var sign = value < 0 ? '-' : '';
    var digitsRE = /(\d{3})(?=\d)/g;
    return sign + _currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
});
new Vue({
    router,
    store,
    created() {


    },
    render: h => h(App),
}).$mount('#app');
